<template>
  <div id="RightNavSimulator" class="theme-background">
    <!-- As abas sempre respondem ao clique: sem objeto daquele tipo selecionado, mostram a lista dele -->
    <v-tabs v-model="tab" flat grow active-class="active" class="sim-tabs">
      <v-tab @click="setSelectedTokenAction('')">Cell</v-tab>
      <v-tab>Geometry</v-tab>
      <v-tab>Sources</v-tab>
      <v-tab>Outputs</v-tab>
    </v-tabs>

    <!-- Aba sem objeto selecionado do mesmo tipo: escolher na lista ou criar -->
    <section v-if="pickerKind" class="pa-4">
      <template v-if="pickerKind === 'flux' && is3d">
        <p class="text-body-2 mb-1">Outputs are not used in 3D.</p>
        <p class="text-caption mb-0">
          Spectra (transmission, reflection) and resonances are computed by the 2D simulator.
          The 3D results always include the field on a cut and the energy flow.
        </p>
      </template>
      <template v-else>
        <p class="text-caption mb-2">{{ pickerHint }}</p>
        <v-list dense class="pa-0 transparent">
          <v-list-item
            v-for="item in pickerItems"
            :key="item.token"
            link
            @click="setSelectedTokenAction(item.token)"
          >
            <v-list-item-icon class="mr-3">
              <v-icon small :color="item.fill">{{ pickerIcon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item>
        </v-list>
        <p v-if="!pickerItems.length" class="text-body-2 mb-0">{{ emptyHint }}</p>
      </template>
    </section>

    <v-expansion-panels v-else multiple accordion :value="[0, 1, 2, 3, 4]" mandatory>
      <CellProperties />
      <Dimensions :is3d="is3d"/>
      <Position :is3d="is3d"/>
      <FluxParameters />
      <SourceProperties />
      <Material />
      <!-- Preenchimento geométrico só existe no 2D (o Gmsh não o usa) -->
      <Fill v-if="!is3d" />
    </v-expansion-panels>
    <PlotOptions :is3d="is3d"/>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "",
  components: {
    FluxParameters: () =>
      import("@/components/RightNavSimulatorFluxParameters"),
    CellProperties: () =>
      import("@/components/RightNavSimulatorCellProperties"),
    Dimensions: () => import("@/components/RightNavSimulatorDimensions"),
    Position: () => import("@/components/RightNavSimulatorPosition"),
    SourceProperties: () =>
      import("@/components/RightNavSimulatorSourceProperties"),
    Material: () => import("@/components/RightNavSimulatorMaterial"),
    PlotOptions: () => import("@/components/RunSimulationPlotOptions"),
    Fill: () => import("@/components/RightNavSimulatorFill")
  },
  props: {
    is3d: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tab: 0
    };
  },
  computed: {
    ...mapGetters("simulator", ["geometryData", "selectedToken", "GeometryList", "SourcesList", "FluxList"]),
    // Tipo da aba aberta (null na aba Cell) e se ela precisa da lista de escolha
    tabKind() {
      return [null, "geometry", "source", "flux"][this.tab] || null;
    },
    pickerKind() {
      if (!this.tabKind) return null;
      const selected = this.geometryData && this.geometryData.class;
      return selected === this.tabKind ? null : this.tabKind;
    },
    pickerItems() {
      return { geometry: this.GeometryList, source: this.SourcesList, flux: this.FluxList }[this.pickerKind] || [];
    },
    pickerIcon() {
      return { geometry: "mdi-shape", source: "mdi-circle-medium", flux: "mdi-access-point" }[this.pickerKind];
    },
    pickerHint() {
      return {
        geometry: "Choose a geometry to edit its size, position and material:",
        source: "Choose a source to edit its wavelength and type:",
        flux: "Choose an output to edit it:"
      }[this.pickerKind];
    },
    emptyHint() {
      return {
        geometry: "No geometries yet. Pick a shape in the toolbar and click (3D) or drag (2D) on the canvas.",
        source: "No sources yet. Choose the source tool in the toolbar and click on the canvas.",
        flux: "No outputs yet. Choose the output tool in the toolbar and click on the canvas."
      }[this.pickerKind];
    }
  },
  watch: {
    geometryData: function() {
      if (typeof this.geometryData === "undefined") {
        this.tab = 0;
        return;
      }

      if (this.geometryData.class == "geometry") {
        this.tab = 1;
      } else if (this.geometryData.class == "source") {
        this.tab = 2;
      } else if (this.geometryData.class == "flux") {
        this.tab = 3;
      } else if (this.geometryData.class == "") {
        this.tab = 0;
      }
    }
  },
  methods: {
    ...mapActions("simulator", ["setSelectedTokenAction"])
  }
};
</script>
<style lang="scss">
@import "./syles.scss";
</style>
